/**
 * What a visitor on a phone sees instead of the app, signed in or not: the browser version is for a
 * computer, and on a phone the MoveBuddy app is the one to use. Nothing else — no navigation, no
 * way past it (owner, 24 September 2026). Who counts as a phone is `app/lib/phoneGate.ts`.
 *
 * It is the refusal screen's shape (`pages/refused`): the same auth shell, the phone tile and
 * `MobileAppPointer` with the App Store and Google Play links. It has no button of its own, because
 * the only thing to do here is leave for the store.
 */

import { useTranslation } from 'react-i18next';

import { useDocumentTitle } from '~/shared/lib/useDocumentTitle';
import { PhoneIcon } from '~/shared/ui/AuthIcons';
import { AuthShell } from '~/shared/ui/AuthShell';
import { AuthTile } from '~/shared/ui/AuthTile';
import { MobileAppPointer } from '~/shared/ui/MobileAppPointer';

export function PhoneOnlyScreen() {
  const { t } = useTranslation();
  const title = t('web:mobileOnly.phone.title');
  useDocumentTitle(title);

  return (
    <AuthShell
      lead={<AuthTile icon={PhoneIcon} />}
      title={title}
      subtitle={t('web:mobileOnly.phone.body')}
      heroTag={t('web:auth.tag')}
      heroHeadline={t('auth.land.r5')}
    >
      <MobileAppPointer hint={t('web:mobileOnly.phone.hint')} />
    </AuthShell>
  );
}
